import { brokersService } from '@/services/brokers';
import type { GetBrokerProductsParams } from '@/services/brokers/types';
import { useQuery } from '@tanstack/react-query';

export function useBrokerProducts(
  brokerId: string | undefined,
  params: GetBrokerProductsParams = {}
) {
  return useQuery({
    queryKey: ['broker-products', brokerId, params],
    queryFn: async () => {
      if (!brokerId) throw new Error('ID do corretor não informado');

      const response = await brokersService.getBrokerProducts(brokerId, params);

      if (!response.success || !response.data) {
        throw new Error(response.error ?? 'Erro ao carregar produtos');
      }

      return {
        data: response.data.data,
        meta: response.data.meta,
      };
    },
    enabled: Boolean(brokerId),
    staleTime: 1000 * 60 * 5,
  });
}
